<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditOrgForm" :rules="editOrgRules" ref="addEditOrgForm" label-width="100px" class="demo-ruleForm">
    <el-row>
      <el-col :span="12">
        <el-form-item label="机构名称" prop="entity_name">
          <el-input v-model="addEditOrgForm.entity_name" placeholder="请输入机构名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属组织" prop="orgid">
          <el-cascader v-fixZoom style="width: 100%" :options="orgOptions"
            v-model="addEditOrgForm.orgid" :filterable="true" placeholder="请选择组织" :disabled="true"
            :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
            ref="orgOptions">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="机构类型" prop="investor_nature_code">
          <el-select v-fixZoom v-model="addEditOrgForm.investor_nature_code" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in typeArr" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="机构性质" prop="entity_nature_code">
          <el-radio-group v-model="addEditOrgForm.entity_nature_code">
            <el-radio label="2">民办</el-radio>
            <el-radio label="1">公办</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="占地面积">
          <el-input v-model="addEditOrgForm.extra_info.floor_space" placeholder="请输入占地面积"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="床位数" prop="approved_bed_count">
          <el-input type="number" v-model="addEditOrgForm.approved_bed_count" placeholder="请输入床位数"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="收费区间" prop="">
          <el-input style="width: 100px" type="number" v-model="addEditOrgForm.extra_info.charge_min" placeholder="最低收费"></el-input>&nbsp;~&nbsp;
          <el-input style="width: 100px" type="number" v-model="addEditOrgForm.extra_info.charge_max" placeholder="最高收费"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="收住对象" prop="">
          <el-checkbox-group v-model="addEditOrgForm.extra_info.person_type">
            <el-checkbox v-for="item in typeService" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="成立时间" prop="entity_establish_date">
          <el-date-picker v-fixZoom v-model="addEditOrgForm.entity_establish_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="运营状态" prop="project_operation_code">
          <el-select v-fixZoom v-model="addEditOrgForm.project_operation_code" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in operationArr" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div style="margin-top: 30px;height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditUnit('addEditOrgForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {createentity, updateentity} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditUnit',
  model: {
    prop: 'addUnitShow',
    event: 'change'
  },
  props: {
    unitObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orgOptions: [],
      typeArr: [
        {id: '10', name: '行政机构'},
        {id: '20', name: '事业单位'},
        {id: '21', name: '财政补助事业单位'},
        {id: '22', name: '自收自支事业单位'},
        {id: '30', name: '国有企业单位'},
        {id: '31', name: '民营企业单位'},
        {id: '40', name: '外商独资单位'},
        {id: '41', name: '中外合资单位'},
        {id: '42', name: '中外合作单位'},
        {id: '50', name: '民办非企业单位'},
        {id: '51', name: '社会组织'},
        {id: '60', name: '个人'},
        {id: '99', name: '其他'}
      ],
      operationArr: [
        {id: '1', name: '未运营'},
        {id: '3', name: '正式运营'},
        {id: '2', name: '试运营'},
        {id: '9', name: '不详'}
      ],
      addEditOrgForm: {
        'id': 0,
        'entity_id': '',
        'entity_code': '',
        'entity_name': '',
        'entity_organization_code': '',
        'entity_status': '',
        'entity_approval_certificate_number': '',
        'entity_administrative_level': '',
        'entity_administrative_area_code': '',
        'entity_administrative_area_name': '',
        'entity_address': '',
        'entity_postal_code': '',
        'entity_contact_phone': '',
        'entity_establish_date': '',
        'entity_supervision_department_name': '',
        'entity_registration_type_code': '',
        'entity_nature_code': '',
        'entity_legal_person_nature_code': '',
        'entity_type_code': '',
        'entity_level_code': '',
        'entity_service_item_category_code': '',
        'entity_function_classification_code': '',
        'is_included_in_the_waiting_institution': 0,
        'medical_insurance_networking_mode_code': '',
        'is_open_to_Hong_Kong_Macao_and_Taiwan_and_foreigners': 0,
        'medical_care_combination_mode_code': '',
        'entity_legal_person_name': '',
        'entity_legal_person_identity_card_number': '',
        'entity_legal_person_contact_phone': '',
        'entity_manager_name': '',
        'entity_manager_identity_card_number': '',
        'entity_manager_contact_phone': '',
        'entity_application_acceptance_registration_number': '',
        'entity_application_unit_proposed_name': '',
        'entity_application_acceptance_date': '',
        'entity_application_acceptance_unit_name': '',
        'entity_application_review_opinion': '',
        'entity_application_review_unit_name': '',
        'entity_application_approval_result': '',
        'entity_application_approval_unit_name': '',
        'entity_application_approval_document_number': '',
        'entity_application_approval_date': '',
        'entity_application_approval_license_number': '',
        'practice_date': '0000-00-00',
        'approved_bed_count': 0,
        'entity_construction_project_name': '',
        'project_address': '',
        'project_area_name': '',
        'planned_start_time': '',
        'planned_completion_time': '',
        'project_construction_form_code': '',
        'total_project_investment': 0,
        'fire_inspection_acceptance_mark': 0,
        'fire_inspection_acceptance_approval': '',
        'fire_inspection_acceptance_approval_unit_name': '',
        'fire_inspection_acceptance_date': '0000-00-00',
        'automatic_sprinkler_system_setting_mark': 0,
        'automatic_sprinkler_system_detection_valid_mark': 0,
        'automatic_sprinkler_system_detection_unit_name': '',
        'fire_alarm_system_setting_mark': 0,
        'fire_alarm_system_detection_valid_mark': 0,
        'fire_alarm_system_detection_unit_name': '',
        'fire_safety_inspection_date': '',
        'fire_safety_inspection_unit_name': '',
        'project_preliminary_procedure_code': '',
        'project_construction_civil_engineering_code': '',
        'project_decoration_road_greening_code': '',
        'project_implementation_equipment_addition_code': '',
        'project_fire_safety_certificate_processing_code': '',
        'project_catering_service_license_processing_code': '',
        'project_environmental_assessment_report_processing_code': '',
        'project_establishment_license_processing_code': '',
        'project_operation_code': '',
        'public_utilities_fee_discount_mark_water': false,
        'public_utilities_fee_discount_mark_electricity': false,
        'public_utilities_fee_discount_mark_gas': false,
        'public_utilities_fee_discount_mark_cable_tv': false,
        'business_tax_discount_code': '',
        'enterprise_income_tax_discount_code': '',
        'investor_or_project_constructor_name': '',
        'investor_type_code': '',
        'investor_nature_code': '',
        'investor_or_project_constructor_phone': '',
        'investor_or_project_constructor_address': '',
        'investor_or_project_constructor_manager_name': '',
        'investor_or_project_constructor_manager_phone': '',
        'operating_unit_name': '',
        'applicant_name': '',
        'applicant_id_number': '',
        'applicant_phone': '',
        'entity_land_nature': '',
        'land_acquisition_mode': '',
        'land_ownership_proof_code': '',
        'elevator_installation_mark': false,
        'house_attribute_code': '',
        'house_ownership_proof_code': '',
        'signed_elderly_number': 0,
        'male_elderly_number': 0,
        'female_elderly_number': 0,
        'local_city_elderly_number': 0,
        'other_city_elderly_number': 0,
        'non_local_elderly_number': 0,
        'service_people_number': 0,
        'service_people_times': 0,
        'service_complaint_people_number': 0,
        'service_complaint_people_times': 0,
        'total_staff_number': 0,
        'service_staff_number': 0,
        'orgid': 0,
        extra_info: {
          floor_space: '',
          charge_min: '',
          charge_max: '',
          person_type: [],
          account_name: '',
          bank_name: '',
          bank_account: '',
          use_type: '',
          contact_person: '',
          contact_job: '',
          contact_phone: ''
        }
      },
      typeService: [{id: 1, name: '自理'}, {id: 2, name: '半自理/介护'}, {id: 3, name: '特护'}],
      editOrgRules: {
        entity_name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        orgid: [
          { required: true, message: '请选择所属组织', trigger: 'change' }
        ],
        investor_nature_code: [
          { required: true, message: '请选择机构类型', trigger: 'change' }
        ],
        entity_nature_code: [
          { required: true, message: '请选择机构性质', trigger: 'change' }
        ],
        approved_bed_count: [
          { required: true, message: '请输入床位数', trigger: 'blur' }
        ],
        entity_establish_date: [
          { required: true, message: '请选择成立时间', trigger: 'change' }
        ],
        project_operation_code: [
          { required: true, message: '请选择运营状态', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.orgOptions = this.unitObj.treeData
    if (!this.unitObj.isAdd) {
      // console.log(this.unitObj.entity)
      // this.addEditOrgForm = this.unitObj.entity
      let data = this.clone(this.unitObj.entity)
      let info = {
        floor_space: '',
        charge_min: '',
        charge_max: '',
        person_type: []
      }
      if (data.extra_info) {
        let extra = JSON.parse(data.extra_info)
        info.floor_space = extra.floor_space ? extra.floor_space : ''
        info.charge_min = extra.charge_min ? extra.charge_min : ''
        info.charge_max = extra.charge_max ? extra.charge_max : ''
        info.person_type = extra.person_type ? extra.person_type : []
        info.account_name = extra.account_name ? extra.account_name : ''
        info.bank_name = extra.bank_name ? extra.bank_name : ''
        info.bank_account = extra.bank_account ? extra.bank_account : ''
        info.use_type = extra.use_type ? extra.use_type : ''
        info.contact_person = extra.contact_person ? extra.contact_person : ''
        info.contact_job = extra.contact_job ? extra.contact_job : ''
        info.contact_phone = extra.contact_phone ? extra.contact_phone : ''
      }
      data.extra_info = info
      this.addEditOrgForm = data
    }
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEditUnit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.clone(this.addEditOrgForm)
          let info = JSON.stringify(this.addEditOrgForm.extra_info)
          data.extra_info = info
          if (this.unitObj.isAdd) {
            createentity(data).then(res => {
              this.$notify({ title: '成功', message: '成功新增机构', type: 'success', duration: 2000 })
              this.$emit('updateTable')
              this.$emit('change', false)
            }).catch(() => {})
          } else {
            updateentity(data).then(res => {
              this.$notify({ title: '成功', message: '成功编辑机构', type: 'success', duration: 2000 })
              // this.$emit('updateTable')
              this.$emit('change', false)
            }).catch(() => {})
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/orgComponents/addEditUnit.vue